import { Modal, ModalHead } from '@dixa/lib-shared-habla';
import { useEffect, useState } from 'react';

import { webformEndpointsApi } from 'apis/webformEndpoints';
import { createAppModal } from 'utils/modal';

import {
  EndpointMessengers,
  FormUsage,
} from '../../../../../customForms.types';
import { useFetchMessengers } from '../../../../../hooks';
import { findEndpointsMessengers } from '../../../../../utils';

import { CanDeleteForm, CannotDeleteForm, Loading } from './components';
import styles from './deleteFormModal.module.scss';

const useFetchEndpoints = (formIntegrationId: string) => {
  const { webformEndpoints } = webformEndpointsApi.useReadWebformEndpointsQuery(
    { formIntegrationId },
    {
      selectFromResult: ({ data, ...rest }) => ({
        ...rest,
        webformEndpoints: data?.data.endpoints,
      }),
    },
  );

  return webformEndpoints;
};

type State =
  | {
      type: 'loading';
    }
  | {
      type: 'cannot-delete';
      endpointsMessengers: EndpointMessengers[];
      formUsages: FormUsage[];
    }
  | {
      type: 'can-delete';
    };

export const DeleteFormModal = createAppModal(
  { type: 'settings:deleteForm' },
  ({ isOpen, modal, hide }) => {
    const { form } = modal.arg;
    const [state, setState] = useState<State>({ type: 'loading' });

    const messengers = useFetchMessengers();
    const endpoints = useFetchEndpoints(form.id);

    useEffect(() => {
      if (messengers && endpoints) {
        const endpointsMessengers = findEndpointsMessengers(
          endpoints,
          messengers,
        );

        if (endpointsMessengers.length > 0 || form.usage.length > 0) {
          setState({
            type: 'cannot-delete',
            endpointsMessengers,
            formUsages: form.usage,
          });
        } else {
          setState({ type: 'can-delete' });
        }
      }
    }, [messengers, endpoints, form]);

    const renderContent = () => {
      switch (state.type) {
        case 'loading':
          return <Loading hide={hide} />;
        case 'cannot-delete':
          return (
            <CannotDeleteForm
              endpointsMessengers={state.endpointsMessengers!}
              formUsages={state.formUsages}
              hide={hide}
            />
          );
        case 'can-delete':
          return <CanDeleteForm form={form} hide={hide} />;
      }
    };

    return (
      <Modal isOpen={isOpen} onClose={hide} className={styles.root}>
        <ModalHead title={`Delete "${form.title}" form`} onClose={hide} />
        {renderContent()}
      </Modal>
    );
  },
);
